import { render, staticRenderFns } from "./CopyrightPractice.vue?vue&type=template&id=09e5cc96&scoped=true&"
import script from "./CopyrightPractice.vue?vue&type=script&lang=js&"
export * from "./CopyrightPractice.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightPractice.vue?vue&type=style&index=0&id=09e5cc96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e5cc96",
  null
  
)

export default component.exports